var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "suppliers",
      class: _vm.opened ? "suppliers-opened" : "",
    },
    [
      _c(
        "div",
        { staticClass: "suppliers__label", on: { click: _vm.toggle } },
        [
          _vm._v("\n    Varumärken\n    "),
          _c("span", {
            staticClass: "suppliers__arrow",
            class: _vm.opened
              ? "suppliers__arrow-opened"
              : "suppliers__arrow-closed",
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.opened,
              expression: "opened",
            },
          ],
          staticClass: "suppliers__list",
        },
        [
          _c(
            "ul",
            _vm._l(_vm.suppliers, function (supplier) {
              return _c("li", { key: supplier.term_id }, [
                _c("a", { attrs: { href: _vm.link(supplier) } }, [
                  _vm._v("\n          " + _vm._s(supplier.name) + "\n        "),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Suppliers.vue